



















import { Vue, Component } from 'vue-property-decorator'
import { getRoutes, chooseCollapseInfo, navTo } from './sidebar'
import MenuItem from './MenuItem.vue'

@Component({
  components: {
    MenuItem
  }
})
export default class TheSidebar extends Vue {
  defaultActive = ''
  routes = getRoutes()
  collapse = false

  // TODO show title and user info

  get collapseInfo() {
    return chooseCollapseInfo(this.collapse)
  }

  mounted() {
    this.defaultActive = this.$router.currentRoute.path
  }

  handleSelect(key: string) {
    if (key === 'collapse') {
      this.collapse = !this.collapse
    } else {
      navTo(key) // or get route by emit?
    }
  }
}
